
export default () => ({
  name: null,
  surname: null,
  middleName: null,
  gender: null,
  birthday: null,
  phone: null,
  roomId: null,
  email: null,
  citizen: null,
  documentType: null,
  documentNumber: null,
  expirationDate: null,
  documents: []
})